export default __webpack_public_path__ + "static/cube-static-b0bb3cbcd5e634a0ba96a8e1bfeaae7e.png";